/**
 * CES Brand Intro Scroll Web Component
 * 实现品牌介绍section的渐显动画效果
 * 滚动视差效果使用 CSS sticky 实现，无需 JavaScript
 * 遵循 SOLID 原则：单一职责、开闭原则
 */

(function() {
    'use strict';

    // 检查是否已经定义，防止重复注册
    if (customElements.get('ndev-ces-brand-intro-scroll')) {
        return;
    }

    /**
     * NdevCesBrandIntroScroll Web Component
     * 负责管理品牌介绍section的渐显动画
     * 滚动视差效果由 CSS sticky 实现
     */
    class NdevCesBrandIntroScroll extends HTMLElement {
        constructor() {
            super();
            this.items = [];
            this.observer = null;
            this.scrollHandler = null;
            this.mutationObserver = null;
            this.contentWrapper = null;
            this.isInViewport = false; // 是否在视口内
            this.hasReachedSticky = false; // 是否已经到达过吸顶位置
        }

        connectedCallback() {
            // 延迟初始化，确保 DOM 完全加载
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.init());
            } else {
                // 使用 setTimeout 确保所有脚本都已加载
                setTimeout(() => this.init(), 0);
            }
        }

        disconnectedCallback() {
            this.cleanup();
        }

        /**
         * 初始化组件
         */
        init() {
            this.items = Array.from(this.querySelectorAll('.brand-intro-item'));
            
            if (this.items.length === 0) {
                return;
            }

            // 使用 Intersection Observer 监听组件是否在视口内
            this.initIntersectionObserver();
            
            // 监听滚动更新蒙层透明度（PC端和移动端都启用）
            this.initGradientMask();
            
            // 初始检查：如果组件已经在视口内
            this.checkInitialVisibility();
        }

        /**
         * 初始化 Intersection Observer（用于判断是否在视口内）
         */
        initIntersectionObserver() {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 1
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    // 使用实例变量控制是否在视口内
                    this.isInViewport = entry.isIntersecting && entry.intersectionRatio >= 1;
                });
            }, options);

            // 观察组件自身
            for (const element of this.items) {
                console.log(element.querySelector('.brand-intro-content-wrapper'))
                this.observer.observe(element.querySelector('.brand-intro-content-wrapper'));
            }
        }

        /**
         * 初始化渐变蒙层透明度更新
         * 使用 MutationObserver 监听 brand-intro-content-wrapper 的位置变化
         */
        initGradientMask() {
            const gradientMask = this.querySelector('.brand-intro-gradient-mask');
            const gradientMaskLeft = this.querySelector('.brand-intro-gradient-mask-left');
            const gradientMaskRight = this.querySelector('.brand-intro-gradient-mask-right');
            if (!gradientMask) {
                return;
            }
            
            // 查找 brand-intro-content-wrapper
            this.contentWrapper = this.closest('.ndev-ces-brand-intro')?.querySelector('.brand-intro-content-wrapper');
            if (!this.contentWrapper) {
                return;
            }
            
            // 获取 sticky top 配置值（直接从组件上读取）
            const isPC = window.innerWidth >= 1024;
            this.stickyTop = parseInt(this.dataset.stickyTopDesktop || (isPC ? '0' : '0'), 10);
            this.stickyTopMobile = parseInt(this.dataset.stickyTopMobile || '0', 10);
            console.log(this.stickyTop)
            console.log(this.stickyTopMobile)
            // 同时监听滚动事件，因为 transform 变化可能不会触发 MutationObserver
            let rafId = null;
            this.scrollHandler = () => {
                // 如果不在视口内，不执行更新
                if (!this.isInViewport) {
                    if (this.hasReachedSticky) {
                        gradientMask.style.opacity = 0;
                        gradientMaskLeft.style.opacity = 0;
                        gradientMaskRight.style.opacity = 0;
                    } else {
                        gradientMask.style.opacity = 0.8;
                        gradientMaskLeft.style.opacity = 0.8;
                        gradientMaskRight.style.opacity = 0.8;
                    }
                    return;
                }
                
                if (rafId) {
                    cancelAnimationFrame(rafId);
                }
                
                rafId = requestAnimationFrame(() => {
                    this.updateGradientMask(gradientMask,gradientMaskLeft,gradientMaskRight);
                });
            };
            
            window.addEventListener('scroll', this.scrollHandler, { passive: true });
            // 初始更新一次
            this.updateGradientMask(gradientMask,gradientMaskLeft,gradientMaskRight);
        }
        
        /**
         * 更新渐变蒙层的透明度
         * 透明度变化逻辑：
         * 1. 文字未吸顶时：opacity = 0.8
         * 2. 文字滚动到吸顶：opacity 从 0.8 -> 0
         * 3. 文字吸顶到流出：opacity 从 0 -> 0.8
         * 根据 brand-intro-content-wrapper 的位置来计算
         */
        updateGradientMask(gradientMask,gradientMaskLeft,gradientMaskRight) {
            // 如果不在视口内，不执行更新
            if (!this.isInViewport) {
                return;
            }
            
            if (!this.contentWrapper) {
                return;
            }
            
            const viewportHeight = window.innerHeight;
            const stickyTop = window.innerWidth >= 1024 ? this.stickyTop || 0 : this.stickyTopMobile || 0; // 从配置读取
            console.log(stickyTop)
            // 获取 contentWrapper 的位置
            const rect = this.contentWrapper.getBoundingClientRect();
            const wrapperTop = rect.top;
            const wrapperBottom = rect.bottom;
            const wrapperHeight = rect.height;
            
            // 计算 wrapper 中心位置
            const wrapperCenter = wrapperTop + wrapperHeight / 2;
            
            // 计算透明度逻辑：
            // 1. 文字刚出现时：透明度保持 0.8（不渐显）
            // 2. 文字开始接近吸顶位置时：透明度渐显（0.8 -> 0），直到文字吸顶
            // 3. 文字吸顶后继续往下滑动：透明度保持不变（0）
            // 4. 往上滑动，文字不吸顶了，继续往上：透明度渐隐（0 -> 0.8）
            
            // 判断文字是否已经吸顶
            // 当 stickyTop 为 0 时，使用 wrapperTop 来判断（接近视口顶部）
            // 当 stickyTop 不为 0 时，使用 wrapperCenter 和 stickyTop 的关系来判断
            let isSticky;
            if (stickyTop === 0) {
                // stickyTop 为 0 时，判断 wrapperTop 是否接近或超过视口顶部
                isSticky = wrapperTop <= stickyTop + 50; // 允许50px的容差
            } else {
                // stickyTop 不为 0 时，使用原来的逻辑
                isSticky = wrapperCenter <= (stickyTop * 2);
            }
            
            // 更新是否已经到达过吸顶位置的标记
            if (isSticky) {
                this.hasReachedSticky = true;
                gradientMask.style.opacity = 0;
                gradientMaskLeft.style.opacity = 0;
                gradientMaskRight.style.opacity = 0;
                return;
            } else {
                this.hasReachedSticky = false;
            }
            
            let opacity = 0.8; // 默认透明度
            
            // 如果文字在视口内
            if (wrapperTop < viewportHeight && wrapperBottom > 0) {
                if (isSticky) {
                    // 文字已经吸顶或吸顶以下，透明度为 0
                    opacity = 0;
                } else {
                    // 文字在吸顶位置以上，根据距离计算透明度
                    // 当 stickyTop 为 0 时，使用 wrapperTop 作为距离基准
                    // 当 stickyTop 不为 0 时，使用 wrapperCenter - stickyTop
                    let distanceFromSticky;
                    if (stickyTop === 0) {
                        // 使用 wrapperTop 作为距离，从 600px 开始渐变到 0
                        distanceFromSticky = wrapperTop;
                    } else {
                        // 使用 wrapperCenter - stickyTop
                        distanceFromSticky = wrapperCenter - stickyTop;
                    }
                    
                    // 定义渐变范围：从更早的位置开始渐变，到结束位置
                    // 当 stickyTop 为 0 时，从 wrapperTop 接近视口顶部时开始渐变
                    // 当 stickyTop 不为 0 时，从更早的位置开始渐变
                    let fadeStartDistance;
                    let fadeEndDistance;
                    
                    if (stickyTop === 0) {
                        // stickyTop 为 0 时，从 wrapperTop 接近视口顶部（比如 200px）时开始渐变
                        fadeStartDistance = viewportHeight * 0.5 - 70; // 视口高度的一半，更早触发
                        fadeEndDistance = 50; // 结束渐变的距离（吸顶位置）
                    } else {
                        // stickyTop 不为 0 时，从更早的位置开始渐变
                        fadeStartDistance = stickyTop + 400; // 从 stickyTop + 400px 开始渐变
                        fadeEndDistance = stickyTop; // 结束渐变的距离（吸顶位置）
                    }
                    
                    const fadeRange = fadeStartDistance - fadeEndDistance; // 渐变范围
                    console.log(distanceFromSticky, viewportHeight)
                    console.log(fadeStartDistance)
                    console.log(fadeEndDistance)
                    console.log(fadeRange, distanceFromSticky <= fadeStartDistance && distanceFromSticky >= fadeEndDistance)
                    if (distanceFromSticky <= fadeStartDistance && distanceFromSticky >= fadeEndDistance) {
                        // 在渐变范围内，计算透明度
                        // progress: 0 表示在开始位置（fadeStartDistance，opacity = 0.8），1 表示在结束位置（fadeEndDistance，opacity = 0）
                        const progress = (fadeStartDistance - distanceFromSticky) / fadeRange;
                        // 使用线性变化，整体匀速
                        // 透明度从 0.8 线性渐变到 0
                        // 当 progress = 0 时，opacity = 0.8
                        // 当 progress = 1 时，opacity = 0
                        opacity = 0.8 * (1 - progress);
                    } else if (distanceFromSticky > fadeStartDistance) {
                        // 距离大于 600px，保持不透明
                        opacity = 0.8;
                    } else {
                        // 距离小于 fadeEndDistance，应该已经吸顶了（这种情况理论上不会发生，因为 isSticky 已经判断了）
                        opacity = 0;
                    }
                }
            } 
            
            // 应用计算出的透明度
            gradientMask.style.opacity = Math.max(0, Math.min(0.8, opacity));
            gradientMaskLeft.style.opacity = Math.max(0, Math.min(0.8, opacity));
            gradientMaskRight.style.opacity = Math.max(0, Math.min(0.8, opacity));
        }

        /**
         * 检查初始可见性
         */
        checkInitialVisibility() {
            const rect = this.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            // 判断组件是否在视口内
            this.isInViewport = rect.top < viewportHeight && rect.bottom > 0;
        }

        /**
         * 清理资源
         */
        cleanup() {
            if (this.observer) {
                this.observer.unobserve(this);
                this.observer.disconnect();
                this.observer = null;
            }
            
            if (this.mutationObserver) {
                this.mutationObserver.disconnect();
                this.mutationObserver = null;
            }
            
            if (this.scrollHandler) {
                window.removeEventListener('scroll', this.scrollHandler);
                this.scrollHandler = null;
            }
            
            this.items = [];
            this.contentWrapper = null;
            this.isInViewport = false;
        }
    }

    // 注册自定义元素
    customElements.define('ndev-ces-brand-intro-scroll', NdevCesBrandIntroScroll);
})();